import { render, staticRenderFns } from "./teamProperty.vue?vue&type=template&id=0472936e&scoped=true"
import script from "./teamProperty.vue?vue&type=script&lang=js"
export * from "./teamProperty.vue?vue&type=script&lang=js"
import style0 from "./teamProperty.vue?vue&type=style&index=0&id=0472936e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472936e",
  null
  
)

export default component.exports